import React, { useEffect } from "react";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { useDispatch, useSelector } from "react-redux";
import { AlertsHolder } from "@visiblethread/react-components/dist/components/Alert";
import PropTypes from "prop-types";
import DictionarySearchDocument from "layout/dictionarySearch/document";
import DictionarySearchHeader from "layout/dictionarySearch/DictionarySearchHeader";
import {
  setSelectedFolderAndDocument,
  setFolderBy,
} from "slices/dictionarySearch/dictionarySearchSlice";
import DictionarySearchFolder from "layout/dictionarySearch/folder";
import { folderBy } from "layout/dictionarySearch/constants";
import { addToJobQueue } from "slices/app/appSlice";
import ActionRequiredOverlay from "@visiblethread/react-components/dist/components/ActionRequiredOverlay";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";

const DictionarySearch = ({ documentId, folderId, title }) => {
  const dispatch = useDispatch();
  const documentView = folderId !== undefined;
  const stateFolderId = useSelector(
    (state) => state.dictionarySearch.config?.folderId
  );
  const { message, buttonContent, buttonAction } = useSelector(
    (state) => state.app.actionRequired
  );
  let folder;
  let document;
  if (folderId === undefined) {
    folder = documentId;
  } else {
    folder = folderId;
    document = Number(documentId);
  }
  let extRef = `#DocSet_${folder}`;
  if (document !== undefined) {
    extRef += `_DocRef_${document}`;
  }

  useEffect(() => {
    dispatch(
      setSelectedFolderAndDocument({ folderId: folder, documentId: document })
    );
    dispatch(
      dispatch(setFolderBy(documentView ? folderBy.document : folderBy.folder))
    );
    dispatch(addToJobQueue("genericJob"));
  }, [dispatch]);

  return (
    <div className="dictionary_search">
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <ModalsHolder />
      <AlertsHolder />
      {message && message !== "" && (
        <ActionRequiredOverlay
          message={message}
          buttonContent={buttonContent}
          buttonAction={buttonAction}
        />
      )}
      {stateFolderId && (
        <div className="dictionary_search__container">
          <DictionarySearchHeader
            title={title}
            isDocView={documentView}
            extRef={extRef}
          />
          {documentView ? (
            <DictionarySearchDocument />
          ) : (
            <DictionarySearchFolder />
          )}
        </div>
      )}
    </div>
  );
};
export default DictionarySearch;
DictionarySearch.propTypes = {
  folderId: PropTypes.number,
  documentId: PropTypes.number,
  title: PropTypes.string.isRequired,
};
